import { type Writable, writable } from 'svelte/store'

export const overlays: Writable<Map<string, boolean>> = writable(new Map<string, boolean>())
